import { StyleSheet, View } from '../../compiler'

import { colors, typoStyles } from '../../constants'
import { useTranslationContext } from '../../context/general-translations'
import { isNumber } from '../../utils'
import { getColors } from '../../utils/matching-profile'
import BeamGraph from '../graphs/BeamGraph'
import MarkdownText from '../MarkdownText'

const styles = StyleSheet.create({
  container: {
    borderRadius: 8,
    overflow: 'hidden',
    borderWidth: 1,
    borderColor: '#EBF0F5'
  },
  top: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingRight: 24,
    height: 72,
    borderBottomWidth: 1,
    borderColor: '#EBF0F5'
  },
  dimension: {
    position: 'relative',
    flexDirection: 'row',
    alignItems: 'center',
    height: 72,
    paddingRight: 24
  },
  numberContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    width: 40,
    height: 40,
    borderRadius: 20,
    borderWidth: 2,
    borderColor: colors.primaryBlue,
    marginRight: 8
  },
  fitMarker: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: 8,
    height: '100%'
  },
  prioBadge: {
    paddingHorizontal: 10,
    paddingVertical: 8,
    backgroundColor: colors.paleBlue,
    borderRadius: 999,
    ...typoStyles.T2MediumBlue
  },
  dimensionBottom: {
    borderTopWidth: 1,
    borderColor: '#EBF0F5',
    backgroundColor: '#FAFBFC',
    padding: 24
  }
})

const getBeamGraphData = ({ match }) => {
  const { user_dimension_value } = match

  return { userDimensionValue: user_dimension_value }
}

const PrioBadge = ({ style, prio }) => {
  const { tGeneral } = useTranslationContext()

  return (
    <View style={[styles.prioBadge, style]}>
      <MarkdownText>
        {tGeneral('riasec_prio_badge_label', { prio })}
      </MarkdownText>
    </View>
  )
}

const Insight = ({
  index,
  dimension,
  match,
  withMarker,
  language,
  renderedInDetailsMessage
}) => {
  const { medium } = withMarker ? getColors({ fit: match.dimension_match }) : {}

  return (
    <View style={[styles.dimension, { paddingLeft: withMarker ? 24 + 8 : 24 }]}>
      {withMarker && (
        <View style={[styles.fitMarker, { backgroundColor: medium }]} />
      )}
      {isNumber(index) && (
        <View style={styles.numberContainer}>
          <MarkdownText style={typoStyles.T1Blue}>{`0${
            index + 1
          }`}</MarkdownText>
        </View>
      )}
      <MarkdownText
        style={[typoStyles.H4Black, { textTransform: 'uppercase' }]}
      >
        {dimension.property[language]}
      </MarkdownText>
      {match.talent_prio && (
        <PrioBadge style={{ marginLeft: 8 }} prio={match.talent_prio} />
      )}
      <View
        style={{
          width: renderedInDetailsMessage ? 175 : 452,
          marginLeft: 'auto'
        }}
      >
        <BeamGraph {...getBeamGraphData({ match })} />
        <View
          style={{
            flexDirection: 'row',
            justifyContent: 'space-between',
            marginTop: 8
          }}
        >
          <MarkdownText style={typoStyles.SmallBlack}>
            {dimension.scaleEndpoints.left.title[language]}
          </MarkdownText>
          <MarkdownText style={typoStyles.SmallBlack}>
            {dimension.scaleEndpoints.right.title[language]}
          </MarkdownText>
        </View>
      </View>
    </View>
  )
}

const RiasecInsights = ({
  insights,
  // talent_top_three,
  career_top_three,
  career_the_others,
  language,
  containerStyle,
  renderedInDetailsMessage = false
}) => {
  const { tGeneral } = useTranslationContext()

  return (
    <View style={containerStyle}>
      <View style={styles.container}>
        <View style={[styles.top, { paddingLeft: 24 + 8 }]}>
          <MarkdownText
            style={[typoStyles.H4Black, { xtextTransform: 'uppercase' }]}
          >
            {tGeneral('riasec_top_three_title')}
          </MarkdownText>
        </View>
        {career_top_three.map(({ dimension, match }, index) => (
          <Insight
            key={index}
            {...{
              index,
              dimension,
              match,
              withMarker: true,
              language,
              renderedInDetailsMessage
            }}
          />
        ))}
      </View>
      <View style={[styles.container, { marginTop: 16 }]}>
        <View style={[styles.top, { paddingLeft: 24 }]}>
          <MarkdownText
            style={[typoStyles.H4Black, { xtextTransform: 'uppercase' }]}
          >
            {tGeneral('riasec_more_title')}
          </MarkdownText>
        </View>
        {career_the_others.map(({ dimension, match }, index) => (
          <Insight
            key={index}
            {...{ dimension, match, language, renderedInDetailsMessage }}
          />
        ))}
        <View style={styles.dimensionBottom}>
          <MarkdownText style={[typoStyles.T1Black, { lineHeight: 1.5 }]}>
            {insights}
          </MarkdownText>
        </View>
      </View>
    </View>
  )
}

export default RiasecInsights
